"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var utilts_1 = require("./utilts");
var Icon = function (_a) {
    var name = _a.name, _b = _a.size, size = _b === void 0 ? 'm' : _b, _c = _a.type, type = _c === void 0 ? 'outlined' : _c;
    return ((0, jsx_runtime_1.jsx)("span", __assign({ className: "material-icons".concat(type === 'filled' ? '' : "-".concat(type)), style: {
            fontSize: (0, utilts_1.getIconFontSize)(size),
        } }, { children: name })));
};
exports.default = Icon;
